namespace GeniuzPOS.CustomReport {
    export interface ReportCusAgingRow {
        Id?: string;
        Category1?: string;
        Category2?: string;
        Category3?: string;
        SkuCode?: string;
        PluCode?: string;
        SkuDesc?: string;
        SupplierId?: string;
        SuplierName?: string;
        BrandName?: string;
        CostPriceExVat?: number;
        RetailPrice?: number;
        SumOnHandQty?: number;
        SumCostValue?: number;
        SumRetailPrice?: number;
        P1Qty?: number;
        P1CostValue?: number;
        P1TotalToStock?: number;
        P2Qty?: number;
        P2CostValue?: number;
        P2TotalToStock?: number;
        P3Qty?: number;
        P3CostValue?: number;
        P3TotalToStock?: number;
        P4Qty?: number;
        P4CostValue?: number;
        P4TotalToStock?: number;
        P5Qty?: number;
        P5CostValue?: number;
        P5TotalToStock?: number;
        HistorySaleAmt?: number;
        AvgSaleAmt?: number;
    }

    export namespace ReportCusAgingRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Category1';
        export const localTextPrefix = 'CustomReport.ReportCusAging';
        export const deletePermission = '6CustomReport:Aging Report:View';
        export const insertPermission = '6CustomReport:Aging Report:View';
        export const readPermission = '6CustomReport:Aging Report:View';
        export const updatePermission = '6CustomReport:Aging Report:View';

        export declare const enum Fields {
            Id = "Id",
            Category1 = "Category1",
            Category2 = "Category2",
            Category3 = "Category3",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            SkuDesc = "SkuDesc",
            SupplierId = "SupplierId",
            SuplierName = "SuplierName",
            BrandName = "BrandName",
            CostPriceExVat = "CostPriceExVat",
            RetailPrice = "RetailPrice",
            SumOnHandQty = "SumOnHandQty",
            SumCostValue = "SumCostValue",
            SumRetailPrice = "SumRetailPrice",
            P1Qty = "P1Qty",
            P1CostValue = "P1CostValue",
            P1TotalToStock = "P1TotalToStock",
            P2Qty = "P2Qty",
            P2CostValue = "P2CostValue",
            P2TotalToStock = "P2TotalToStock",
            P3Qty = "P3Qty",
            P3CostValue = "P3CostValue",
            P3TotalToStock = "P3TotalToStock",
            P4Qty = "P4Qty",
            P4CostValue = "P4CostValue",
            P4TotalToStock = "P4TotalToStock",
            P5Qty = "P5Qty",
            P5CostValue = "P5CostValue",
            P5TotalToStock = "P5TotalToStock",
            HistorySaleAmt = "HistorySaleAmt",
            AvgSaleAmt = "AvgSaleAmt"
        }
    }
}
